export const logo: {
  logo: string;
} = {
  logo: 'https://www.myalex.com/assets/alex-logo-f5df86c4af070b32bcf40d161f0ed27dd09d0421cbdeab2248b3c317cd29a565.svg',
};
